import { Injectable }    from '@angular/core';

import { Developer } from '../../classes/developer';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

@Injectable()
export class DeveloperService extends UserService {

  constructor(
    protected requestService: RequestService, 
    protected auth: Auth
  ) { super(requestService, auth); }

  protected getUsersUrl(): string {

    return 'developers';
  };

  protected getOneUserUrl(): string {

    return 'developer';
  };

  protected parseObject(obj: any): Developer {

    return obj as Developer;
  };

  protected parseArray(objs: any): Developer[] {

    return objs as Developer[];
  };
}


// WEBPACK FOOTER //
// ./src/app/services/developers/developer.service.ts